interface Props {
  label?: string;
}
export default function Spinner({ label = 'Carregando…' }: Props) {
  return (
    <div className="d-flex align-items-center gap-2 text-muted small py-3">
      <div
        className="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      />
      <span>{label}</span>
    </div>
  );
}
